import axios from "axios";
import { clearUserData } from "../redux/reducers/userReducer";
import { clearSchoolData } from "../redux/reducers/schoolReducer";
import { clearDashboardData } from "../redux/reducers/dashboardReducer";
import { clearLoadingData } from "../redux/reducers/loadingReducer";

var totalRequest = 0;
// Create an Axios instance
const axiosInstance = axios.create({
     //   baseURL: "https://api.example.com", // Replace with your API base URL
     timeout: 10000,
});

// Request Interceptor
axiosInstance.interceptors.request.use(
     (config) => {
          totalRequest++;
          // Add authorization token if available
          const userToken = localStorage.getItem("userToken");
          const token = userToken ? JSON.parse(userToken) : userToken;

          if (token) {
               // config.headers.Authorization = `Bearer ${token}`;
               config.headers["Accept"] = "application/json";
               config.headers["Content-Type"] = "application/json";
               config.headers["x-access-token"] = token;
          }
          return config;
     },
     (error) => {
          // totalRequest--;
          return Promise.reject(error);
     }
);


export const setupInterceptors = (store) => {
     // Response Interceptor
     axiosInstance.interceptors.response.use(
          (response) => {
               // totalRequest--;
               totalRequest = Math.max(totalRequest - 1, 0);

               // spinning hide
               if (totalRequest === 0) {
                    store.dispatch(clearLoadingData());
               }

               if (response.data.statusCode === 403 && typeof response.data.message == "object" && response.data.message.name === "TokenExpiredError") {
                    localStorage.removeItem("userToken");
                    localStorage.removeItem("persist:root");
                    store.dispatch(clearUserData());
                    store.dispatch(clearSchoolData());
                    store.dispatch(clearDashboardData());
                    // await setUserToken("");
                    // navigate("/", { replace: true });
                    window.location.href = "/";
               }
               return response;
          }, // Return response normally
          (error) => {
               // totalRequest--;
               totalRequest = Math.max(totalRequest - 1, 0);
               if (totalRequest === 0) {
                    store.dispatch(clearLoadingData());
               }
               if (!error.response) {
                    // Network error, server down, or timeout

                    // Dispatch an action to show error in UI
                    // store.dispatch(showErrorNotification("Network issue. Please try again later."));
               } else {
                    const { status } = error.response;

                    if (status === 401 || status === 502) {
                         localStorage.removeItem("userToken");
                         localStorage.removeItem("persist:root");
                         store.dispatch(clearUserData());
                         store.dispatch(clearSchoolData());
                         store.dispatch(clearDashboardData());
                         //    await setUserToken("");
                         window.location.href = "/";
                    }
               }
               return Promise.reject(error);
          }
     );
};

export default axiosInstance;
